import React from 'react';

const PageLoader = () => {
  return (
    <div className="flex justify-center items-center h-[30vh]">
      <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default PageLoader;
